import React, { useCallback, useState } from 'react'
import { useSelector } from 'react-redux'
import { Redirect } from 'react-router-dom'

import { subscribe } from '../../../utils/stripe'

import { getCurrentOrganization } from '../../../ducks/users'
import AppLoader from '../../App/AppLoader'
import Button from '../../Shared/Button'
import AuthPage from '../../Shared/AuthPage'
import Card from '../../Shared/Card'
import FormError from '../../Shared/Forms/FormError'

import PlanSelector from './PlanSelector'

export default function OnboardingSubscribe() {
  const [submitting, setSubmitting] = useState(false)
  const [plan, setPlan] = useState('starter')
  const [error, setError] = useState(null)
  const org = useSelector(getCurrentOrganization)
  const orgId = org && org.id

  const handlePay = useCallback(async () => {
    setSubmitting(true)

    try {
      await subscribe(orgId, plan)
    } catch (err) {
      setError(err.message)
    }

    setSubmitting(false)
  }, [orgId, plan])

  if (org && org.activePlan) {
    return <Redirect to="/" />
  }

  return (
    <AppLoader>
      <AuthPage wide>
        <Card
          actions={
            <Button onClick={handlePay} loading={submitting}>
              Continue
            </Button>
          }
        >
          <h1>Choose a Plan</h1>
          <PlanSelector currentPlan={plan} onChangePlan={setPlan} />
          {error && <FormError>{error}</FormError>}
        </Card>
      </AuthPage>
    </AppLoader>
  )
}
